import { popup } from "@tma.js/sdk";
import { AxiosError } from "axios";

type AsyncFunction<T = any> = () => Promise<T>;

interface AsyncHandlerOptions<T = any> {
  onSuccess?: (data: T) => void;
  onError?: (error: any) => void;
  successMessage?: string;
  errorMessage?: string;
  showSuccessNotification?: boolean;
  showErrorNotification?: boolean;
}

export const withAsyncHandler = async <T = any>(
  asyncFn: AsyncFunction<T>,
  setLoading: (loading: boolean) => void,
  options: AsyncHandlerOptions<T> = {},
): Promise<T | null> => {
  const {
    onSuccess,
    onError,
    successMessage,
    errorMessage,
    showSuccessNotification = false,
    showErrorNotification = true,
  } = options;

  setLoading(true);

  try {
    const data = await asyncFn();
    const message = successMessage || (data as any)?.message;

    if (showSuccessNotification && message) {
      // popup.show({ message, buttons: [{ type: "close" }] }).then(() => {
      // });
      onSuccess?.(data);
    } else {
      onSuccess?.(data);
    }

    return data;
  } catch (error) {
    const axiosError = error as AxiosError<{ message?: string }>;
    const message =
      axiosError.response?.data?.message ||
      errorMessage ||
      "An error occurred. Please try again.";

    if (showErrorNotification) {
      popup.show({ message, buttons: [{ type: "close" }] }).then(() => {
        onError?.(error);
      });
    } else {
      onError?.(error);
    }

    console.error("Async handler error:", error);
    return null;
  } finally {
    setLoading(false);
  }
};
